import { BoxplotSeriesOption } from "echarts";
import { createStateWithDefaults } from "entities/utils";
import { SeriesType } from "types/echarts";

import { getJitterPlotPosition } from "components/charts/utils/getJitterPlotPosition";

export const DEFAULT_BOX_PLOT_OPTIONS: Partial<BoxplotSeriesOption> = {
  type: SeriesType.BoxPlot,
  name: "",
  blur: {}
};

export const generateBoxPlotSeriesOptions = createStateWithDefaults(
  DEFAULT_BOX_PLOT_OPTIONS
);

export function renderJitterPlotItem(params, api) {
  const point = api.value(0);
  if (point == null || isNaN(point)) {
    return;
  }
  return getJitterPlotPosition(api, 10);
}
